import React from "react";
// ANT DESIGN COMPONENTS
import { Tag } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// FLATBUFFERS
import { UserStatus } from "../../../flatbuffers/generated/archive/user-status";
// STATUS METADATA
import {
  USER_STATUS_META,
  userStatusColor,
  userStatusIcon,
  userStatusLabelKey,
} from "../../../components/users/userStatusMeta";

interface TableColumnStatusUserProps {
  /** The stored `user_status` discriminant. */
  text: UserStatus | number | null | undefined;
}

/**
 * The status tag for one user row.
 *
 * Colour, icon and label all come from USER_STATUS_META — the same map
 * UserStatusLegend renders — so the tag and the legend that explains it cannot
 * disagree. They did: this column painted OFFLINE_CREATED blue while the legend
 * called it gold. The table's colours are the ones kept -- they are pinned by
 * e2e/investigate-user-status.spec.ts, and unifying two lists is no reason to
 * change what an operator sees. What this replaces is the seven-branch chain,
 * which had to be edited alongside the map for every schema change and was not.
 *
 * A status with no entry renders nothing rather than an untagged cell, which is
 * the same thing the old chain did for a value it did not recognise.
 */
function TableColumnStatusUser({ text }: TableColumnStatusUserProps) {
  const [t] = useTranslation("global");

  if (text === null || text === undefined) return null;

  const status = text as UserStatus;
  if (!USER_STATUS_META[status]) return null;

  return (
    <div>
      <Tag
        color={userStatusColor(status)}
        icon={<FontAwesomeIcon icon={userStatusIcon(status)} className="generalStyles__mrFix" />}
        className="drawer__tag generalStyles__textCenter generalStyles__width100px"
      >
        {t(userStatusLabelKey(status))}
      </Tag>
    </div>
  );
}

export default TableColumnStatusUser;
